interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'Article' | 'FAQPage';
  data?: Record<string, unknown>;
}

const baseSchemas = {
  Organization: {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '草榴社区技术讨论区',
    url: 'https://techcommunity.cn',
    description: '技术爱好者专业交流平台，汇聚编程、网络安全、人工智能等技术话题',
    sameAs: ['https://github.com/techcommunity', 'https://weibo.com/techcommunity'],
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'contact@techcommunity.cn',
      contactType: 'customer service',
    },
  },
  WebSite: {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '草榴社区技术讨论区',
    url: 'https://techcommunity.cn',
    description: '技术交流与资源分享平台，提供编程技术讨论、网络技术分享、技术问答等服务',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: 'https://techcommunity.cn/search?q={search_term_string}',
      },
      'query-input': 'required name=search_term_string',
    },
  },
};

const SchemaOrg = ({ type, data }: SchemaOrgProps) => {
  let schema: Record<string, unknown>;

  if (type === 'Organization' || type === 'WebSite') {
    schema = baseSchemas[type];
  } else {
    schema = {
      '@context': 'https://schema.org',
      '@type': type,
      ...data,
    };
  }

  return <script type="application/ld+json">{JSON.stringify(schema)}</script>;
};

export default SchemaOrg;